import React from "react";
import '../../css/MajorTools.css';
const importAll = (r) => {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

const icons = importAll(
  require.context("../../../assets/icons", false, /\.(png|jpe?g|svg)$/)
);
function MajorTools() {
  const leftTools = [
    {
      title: "BrowserStack",
      description:
        "Do cross-browser and real-device tests right from FrothTestops with a smooth integration – this plan includes it.",
      icon: "browserstack.png",
    },
    {
      title: "Jira",
      description:
        "Defects can be logged and test progress can be synchronized automatically with your Jira issues and epics.",
      icon: "jira.png",
    },
    {
      title: "Plane",
      description:
        "By integrating with Playwright you can easily start automated test runs and also get the execution results instantly.",
      icon: "plane.png",
    },
  ];

  const rightTools = [
    {
      title: "GitHub",
      description:
        "Keep your repositories updated and connect test cases with pull requests, commits, and branches.",
      icon: "git.png",
    },
    {
      title: "Python",
      description:
        "Connect your Python-based test framework to run scripts and get the results without any trouble.",
      icon: "python.png",
    },
    {
      title: "GitLab",
      description:
        "With smooth GitLab integration and issue tracking, you can create and control powerful front-end test scenarios.",
      icon: "gitlab.png",
    },
  ];

  return (
    <div className="integration-container">

      {/* Heading */}
      <div className="integration-header">
        <span className="breadcrumb">
          Home / <span>Integration</span>
        </span>

        <h1>Seamless Integrations for Smarter Testing</h1>

        <p>
          Connect FrothTestops with tools you are already using. Modern QA teams can benefit one of the
          <span className="highlight"> best AI testing tools </span>
          from powerful integrations that enhance a testing workflow, simplify collaboration, execution, and reporting.
        </p>
      </div>

      {/* Grid */}
      <div className="integration-grid">

        {/* Left */}
        <div className="tools-column">
  {leftTools.map((tool, index) => (
    <div key={index} className="tool-card">
      <img src={icons[tool.icon]} alt={tool.title} />
      <h3>{tool.title}</h3>
      <p>{tool.description}</p>
    </div>
          ))}
        </div>

        <div className="center-image">
  <img src={icons["illustration.jpg"]} alt="integration" />
</div>

        {/* Right */}
        <div className="tools-column">
  {rightTools.map((tool, index) => (
    <div key={index} className="tool-card">
      <img src={icons[tool.icon]} alt={tool.title} />
      <h3>{tool.title}</h3>
      <p>{tool.description}</p>
    </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default MajorTools;